
export default function Industries() {
  const industries = [
    {
      name: 'Industrial Manufacturing',
      icon: 'ri-factory-line',
      description: 'Heavy machinery, production lines, and manufacturing equipment components',
      image: '/img/manufacturing.jpg'
    },
    {
      name: 'Automotive',
      icon: 'ri-car-line',
      description: 'Automotive parts, transmission components, and vehicle maintenance supplies',
      image: '/img/automotive.jpg'
    },
    {
      name: 'MRO Services',
      icon: 'ri-tools-line',
      description: 'Maintenance, repair, and operations supplies for facility management',
      image: '/img/mro.jpg'
    },
    {
      name: 'Marine',
      icon: 'ri-ship-line',
      description: 'Marine equipment, ship components, and offshore platform supplies',
      image: '/img/marine.jpg'
    },
    {
      name: 'Construction',
      icon: 'ri-building-line',
      description: 'Construction machinery parts, heavy equipment components, and building supplies',
      image: '/img/construction.jpg'
    },
    {
      name: 'Pharmaceutical',
      icon: 'ri-capsule-line',
      description: 'Pharmaceutical equipment, cleanroom components, and precision instruments for drug manufacturing',
      image: '/img/pharmaceutical.jpg'
    }
  ];

  return (
    <section id="industries" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Industries <span className="text-blue-600">We Serve</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Providing specialized solutions across diverse industrial sectors with expertise and reliability
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden hover:transform hover:scale-105"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/90 rounded-lg flex items-center justify-center">
                    <i className={`${industry.icon} text-2xl text-blue-600`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-900">
                  {industry.name}
                </h4>
                <p className="text-gray-600 group-hover:text-gray-700 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-6">
            Serving clients across the Middle East, Asia, Africa, and beyond
          </p>
          <div className="flex justify-center items-center space-x-8 text-blue-600">
            <div className="text-center">
              <div className="text-3xl font-bold">40+</div>
              <div className="text-sm text-gray-600">Countries</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold">1000+</div>
              <div className="text-sm text-gray-600">Clients</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold">24/7</div>
              <div className="text-sm text-gray-600">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
